module.exports = __webpack_public_path__ + "img/stage-6.9958d1a4.png";